import p1 from "./Pimg/Amala, Ewedu & Gbegiri + 2 Mini Beef N3,700.jpg"
import p2 from "./Pimg/Amala, Ewedu & Gbegiri N1,550.jpg"
import p3 from "./Pimg/Asun (Goat Meat) N4,500.jpg"
import p4 from "./Pimg/Asun Fried Rice N4,900.jpg"
import p5 from "./Pimg/Asun Pepper Rice + Fried Plantain N8,750.jpg"
import p6 from "./Pimg/Asun Pepper Rice N5,600.jpg"
import p7 from "./Pimg/BBQ Chicken N3,350.jpg"
import p8 from "./Pimg/Basmati Jellof Rice N3,500.jpg"
import p9 from "./Pimg/Beans Pottage N2,550.jpg"
import p10 from "./Pimg/Beef Asun N4,650.jpg"
import p11 from "./Pimg/Boiled Egg N700.jpg"
import p12 from "./Pimg/Caribbean Rice N3,700.jpg"
import p13 from "./Pimg/Chicken Pie N2,300.jpg"
import p14 from "./Pimg/Chicken in Stew - Small N3,350.jpg"
import p15 from "./Pimg/Chivita Juice 1L Pack N5000.jpg"
import p16 from "./Pimg/Coca-Cola Original 35cl N800.jpg"
import p17 from "./Pimg/Coca-Cola Original 50cl PET N1,300.jpg"
import p18 from "./Pimg/Coleslaw Salad N2,300.jpg"
import p19 from "./Pimg/Crispy Fried Yam N2,500.jpg"
import p20 from "./Pimg/Croaker Fish in Stew - Big N5,950.jpg"
import p21 from "./Pimg/Eba N900.jpg"
import p22 from "./Pimg/Edikaikong N4,650.jpg"
import p23 from "./Pimg/Eforiro Soup N3,250.jpg"
import p24 from "./Pimg/Egusi Soup N1,550.jpg"
import p25 from "./Pimg/Eva water 75cl PET N900.jpg"
import p26 from "./Pimg/Extra Large Value Munch - Fried Rice & Beef N3,500.jpg"
import p27 from "./Pimg/Extra Large Value Munch - Fried Rice & Chicken N3,050.jpg"
import p28 from "./Pimg/Extra Large Value Munch - Joffof Rice & Chicken N4,050.jpg"
import p29 from "./Pimg/Extra Large Value Munch - Jollof Rice & Fried Rice & Chicken.jpg"
import p30 from "./Pimg/Fanta N900.jpg"
import p31 from "./Pimg/Fanta Orange 50cl PET N1,300.jpg"
import p32 from "./Pimg/Fiesta Fried Rice N4,300.jpg"
import p33 from "./Pimg/Fried Curry Chicken N3,350.jpg"
import p34 from "./Pimg/Fried Plantain N2,650.jpg"
import p35 from "./Pimg/Grilled Chicken - 1_4 N6,200.jpg"
import p36 from "./Pimg/Grilled Turkey Wings (Medium) N7,350.jpg"
import p37 from "./Pimg/Honey BBQ Chicken N3,500.jpg"
import p38 from "./Pimg/Jellof Rice N2,550.jpg"
import p39 from "./Pimg/Malta Guinness 33cl Can N2,300.jpg"
import p40 from "./Pimg/Meat Pie N2,300.jpg"
import p41 from "./Pimg/Mini Beef N900.jpg"
import p42 from "./Pimg/Panla Fish - Big N3,850.jpg"
import p43 from "./Pimg/Ponmo N1,700.jpg"
import p44 from "./Pimg/Pounded Yam N900.jpg"
import p45 from "./Pimg/Prawn Rice N4,300.jpg"
import p46 from "./Pimg/Pulpy Drink 85cl N3,950.jpg"
import p47 from "./Pimg/Regular Value Munch - Fried Rice & Beef N2,650.jpg"
import p48 from "./Pimg/Regular Value Munch - Fried Rice & Curry Chicken N3,600.jpg"
import p49 from "./Pimg/Rice & Beans N2,800.jpg"
import p50 from "./Pimg/Rich Jellof Rice N4,500.jpg"
import p51 from "./Pimg/Semo N900 .jpg"
import p52 from "./Pimg/Shaki N1,900.jpg"
import p53 from "./Pimg/Share a Coke Regular Value Munch - Rice + Chicken + 50cl Coke N3,910.jpg"
import p54 from "./Pimg/Share a Coke Small Value Munch - Rice + Chicken + 50cl Coke N4,200.jpg"
import p55 from "./Pimg/Share a Coke XL Value Munch - Rice + Chicken + 50cl Coke N5,000.jpg"
import p56 from "./Pimg/Small Snail N5,700.jpg"
import p57 from "./Pimg/Small Value Munch - Fried Rice & Chicken in Stew N3,250.jpg"
import p58 from "./Pimg/Spaghetti + Barbeque Chicken N5,850.jpg"
import p59 from "./Pimg/Special Fried Rice N4,500.jpg"
import p60 from "./Pimg/Stir Fry Spaghetti N4,650.jpg"
import p61 from "./Pimg/Sugar & Jam Doughnut - N1,550.jpg"
import p62 from "./Pimg/Titus Fish - Big N4,200.jpg"
import p63 from "./Pimg/Turkey Rice + Fried Plantain N9,500.jpg"
import p64 from "./Pimg/Turkey Rice N7,200.jpg"
import p65 from "./Pimg/Utterly Yum Juice 50cl N4,550.jpg"
import p66 from "./Pimg/Village Rice N2,900.jpg"







const products = [

  {
    id: 36,
    name: "Grilled Turkey Wings (Medium) ",
    category: "protein",
    price: 7350,
    image: p36 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
 
  {
    id: 38,
    name: "Jellof Rice",
    category: "jellof rice options",
    price: 2550,
    image: p38 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 39,
    name: "Malta Guinness 33cl Can",
    category: "drinks",
    price: 2300,
    image: p39 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 40,
    name: "Meat Pie",
    category: "snacks",
    price: 2300,
    image: p40 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 41,
    name: "Mini Beef",
    category: "protein",
    price: 900,
    image: p41 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 42,
    name: "Panla Fish - Big",
    category: "protein",
    price: 3850,
    image: p42 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 43,
    name: "Ponmo",
    category: "protein",
    price: 1700,
    image: p43 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 44,
    name: "Pounded Yam",
    category: "swallow",
    price: 900,
    image: p44 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 45,
    name: "Prawn Rice",
    category: "mains",
    price: 4300,
    image: p45 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 46,
    name: "Pulpy Drink 85cl",
    category: "drinks",
    price: 3950,
    image: p46 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 47,
    name: "Regular Value Munch - Fried Rice & Beef",
    category: "Regular Value Munch",
    price: 2650,
    image: p47 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 48,
    name: "Regular Value Munch - Fried Rice & Curry Chicken ",
    category: "Regular Value Munch",
    price: 3600,
    image: p48 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 49,
    name: "Rice & Beans",
    category: "mains",
    price: 2800,
    image: p49 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 50,
    name: "Rich Jellof Rice",
    category: "jellof rice options",
    price: 4500,
    image: p50 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
    
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
  {
    id: 51,
    name: "Semo",
    category: "swallow",
    price: 900,
    image: p51 ,
    shopId: "shop007",
    shopName: "Chicken Republic",
      vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
  },
   
     {
      id: 52,
      name: "Shaki",
      category: "protein",
      price: 1900,
      image: p52 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 53,
      name: "Share a Coke Regular Value Munch - Rice + Chicken + 50cl Coke",
      category: "drinks",
      price: 3910,
      image: p53 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 54,
      name: "Share a Coke Small Value Munch - Rice + Chicken + 50cl Coke ",
      category: "drinks",
      price: 4200,
      image: p54 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 55,
      name: "Share a Coke XL Value Munch - Rice + Chicken + 50cl Coke ",
      category: "drinks",
      price: 5000,
      image: p55 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 56,
      name: "Small Snail",
      category: "protein",
      price: 5700,
      image: p56 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 57,
      name: "Small Value Munch - Fried Rice & Chicken in Stew ",
      category: "Small Value Munch",
      price: 3250,
      image: p57 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 58,
      name: "Spaghetti + Barbeque Chicken",
      category: "combos",
      price: 5850,
      image: p58 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 59,
      name: "Special Fried Rice",
      category: "mains",
      price: 4500,
      image: p59 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },

    {
      id: 60,
      name: "Stir Fry Spaghetti",
      category: "mains",
      price: 4650,
      image: p60 ,
      shopId: "shop007",
      shopName: "sides & extras",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 61,
      name: "Sugar & Jam Doughnut ",
      category: "snacks",
      price: 1550,
      image: p61 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 62,
      name: "Titus Fish - Big",
      category: "protein",
      price: 4200,
      image: p62 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 63,
      name: "Turkey Rice + Fried Plantain",
      category: "combos",
      price: 9600,
      image: p63 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 64,
      name: "Turkey Rice",
      category: "combos",
      price: 7200,
      image: p64 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 65,
      name: "Utterly Yum Juice 50cl",
      category: "drinks",
      price: 4550,
      image: p65 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 66,
      name: "Village Rice",
      category: "mains",
      price: 2900,
      image: p66 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 1,
      name: "Amala, Ewedu & Gbegiri + 2 Mini Beef",
      category: "combos",
      price: 3700,
      image: p1 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 2,
      name: "Amala, Ewedu & Gbegiri ",
      category: "combos",
      price: 1550,
      image: p2 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 3,
      name: "Asun (Goat Meat)",
      category: "protein",
      price: 4500,
      image: p3 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 4,
      name: "Asun Fried Rice",
      category: "mains",
      price: 4900,
      image: p4 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 5,
      name: "Asun Pepper Rice + Fried Plantain",
      category: "combos",
      price: 8800,
      image: p5 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 6,
      name: "Asun Pepper Rice",
      category: "mains",
      price: 5600,
      image: p6 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 37,
      name: "Honey BBQ Chicken",
      category: "protein",
      price: 3500,
      image: p37 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 7,
      name: "BBQ Chicken",
      category: "protein",
      price: 3400,
      image: p7 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 8,
      name: "Basmati Jellof Rice",
      category: "mains",
      price: 3500,
      image: p8 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 9,
      name: "Beans Pottage",
      category: "mains",
      price: 2550,
      image: p9 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 10,
      name: "Beef Asun.jpg",
      category: "mains",
      price: 4650,
      image: p10 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 11,
      name: "Boiled Egg",
      category: "protein",
      price: 700,
      image: p11 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 12,
      name: "Caribbean Rice",
      category: "mains",
      price: 3700,
      image: p12 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 13,
      name: "Chicken Pie",
      category: "snacks",
      price: 2300,
      image: p13 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 14,
      name: "Chicken in Stew - Small",
      category: "combos",
      price: 3350,
      image: p14 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 15,
      name: "Chivita Juice 1L Pack",
      category: "drinks",
      price: 5000,
      image: p15 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 16,
      name: "Coca-Cola Original 35cl",
      category: "drinks",
      price: 800,
      image: p16 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 17,
      name: "Coca-Cola Original 50cl PET",
      category: "drinks",
      price: 1300,
      image: p17 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 18,
      name: "Coleslaw Salad",
      category: "sides & extras",
      price: 2300,
      image: p18 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 19,
      name: "Crispy Fried Yam",
      category: "mains",
      price: 2500,
      image: p19 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 20,
      name: "Croaker Fish in Stew - Big",
      category: "combos",
      price: 6000,
      image: p20 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 21,
      name: "Eba.",
      category: "swallow",
      price: 900,
      image: p21 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 22,
      name: "Edikaikong",
      category: "soups",
      price: 4650,
      image: p22 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 23,
      name: "Eforiro Soup",
      category: "soups",
      price: 3250,
      image: p23 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 24,
      name: "Egusi Soup",
      category: "soups",
      price: 1550,
      image: p24 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 25,
      name: "Eva water 75cl PET",
      category: "drinks",
      price: 900,
      image: p25 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 26,
      name: "Extra Large Value Munch - Fried Rice & Beef",
      category: "Extra Large Value Munch",
      price: 3550,
      image: p26 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 27,
      name: "Extra Large Value Munch - Fried Rice & Chicken",
      category: "Extra Large Value Munch",
      price: 3050,
      image: p27 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 28,
      name: "Extra Large Value Munch - Joffof Rice & Chicken",
      category: "Extra Large Value Munch",
      price: 4050,
      image: p28 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 29,
      name: "Extra Large Value Munch - Jollof Rice & Fried Rice & Chicken",
      category: "Extra Large Value Munch",
      price: 6500,
      image: p29 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 30,
      name: "Fanta",
      category: "drinks",
      price: 900,
      image: p30 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 31,
      name: "Fanta Orange 50cl PET",
      category: "drinks",
      price: 1300,
      image: p31 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 32,
      name: "Fiesta Fried Rice",
      category: "combos",
      price: 4300,
      image: p32 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 33,
      name: "Fried Curry Chicken",
      category: "protein",
      price: 3350,
      image: p33 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 34,
      name: "Fried Plantain",
      category: "sides & extras",
      price: 2700,
      image: p34 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    {
      id: 35,
      name: "Grilled Chicken",
      category: "protein",
      price: 6200,
      image: p35 ,
      shopId: "shop007",
      shopName: "Chicken Republic",
      
        vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2"
    },
    

    
  ];
  
  export default products;

  